import { configureStore } from "@reduxjs/toolkit";
import websiteReducer from "../ReduxSlices/websiteSlice";
import pricingReducer from "../ReduxSlices/priceSlice";
import authReducer from "../ReduxSlices/authSlice";
import profileReducer from "../ReduxSlices/profileSlice";
import emailTemplateReducer from "../ReduxSlices/EmailTemplateSlice";
import comapinReducer from "../ReduxSlices/campaignSlice";
import appoloAPiReducer from "../ReduxSlices/newAppoloApiSlice";
import campaignAnalyticsReducer from "../ReduxSlices/analyticsDashboardSlice";
import userPaymentReducer from "../ReduxSlices/paymentSlice";
import contactUsReducer from "../ReduxSlices/contactUsSlice";
import campaignMetricsReducer from "../ReduxSlices/emailMatrixSlice";
import smtpProviderReducer from "../ReduxSlices/smptProviderSlice";
import databaseReducer from "../ReduxSlices/newsearchSlice";
import leadBatchReducer from "../ReduxSlices/leadBatchSlice";
import forgetPasswordReducer from "../ReduxSlices/forgetPasswordSlice";

const store = configureStore({
  reducer: {
    website: websiteReducer,
    pricing: pricingReducer,
    auth: authReducer,
    profile: profileReducer,
    customEmail: emailTemplateReducer,
    campaign: comapinReducer,
    appoloAPi: appoloAPiReducer,
    campaignAnalytics: campaignAnalyticsReducer,
    userPayment: userPaymentReducer,
    contactUs: contactUsReducer,
    campaignMetric: campaignMetricsReducer,
    smptProvider: smtpProviderReducer,
    database: databaseReducer,
    leadbatch: leadBatchReducer,
    forgetpassword:forgetPasswordReducer
  },
});

export default store;
